import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus, X, Check } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { inputCls, btnPrimary, btnGhost, cardCls } from "./styles";
import { ImageField } from "./ImageField";

const EMPTY = { title: "", category: "", image_url: "", visible: true, order: 0 };

export const GalleryTab = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/admin/gallery").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/gallery", { ...form, order: items.length + 1 });
      toast.success("تمت إضافة الصورة");
      setForm(null);
      load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  const toggle = async (g) => {
    try {
      await api.put(`/admin/gallery/${g.id}`, { ...g, visible: !g.visible });
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const del = async (id) => {
    if (!window.confirm("حذف هذه الصورة؟")) return;
    try {
      await api.delete(`/admin/gallery/${id}`);
      toast.success("تم الحذف");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-5">
        <div className="text-sm text-zinc-500">{items.length} صورة — أضف صور الفان والفنيين الحقيقية هنا</div>
        <button data-testid="gallery-add-btn" onClick={() => setForm(EMPTY)} className={`${btnPrimary} flex items-center gap-1.5 shrink-0`}>
          <Plus className="w-4 h-4" /> إضافة صورة
        </button>
      </div>

      {form && (
        <form data-testid="gallery-form" onSubmit={save} className={`${cardCls} mb-5 space-y-3 border-yellow-400/40`}>
          <div className="grid sm:grid-cols-2 gap-3">
            <input data-testid="gallery-title-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="عنوان الصورة *" className={inputCls} required />
            <input data-testid="gallery-category-input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} placeholder="التصنيف — مثال: تغيير إطارات" className={inputCls} />
          </div>
          <ImageField value={form.image_url} onChange={(url) => setForm({ ...form, image_url: url })} testid="gallery-image" />
          <div className="flex gap-2">
            <button type="submit" data-testid="gallery-save-btn" className={`${btnPrimary} flex items-center gap-1.5`}><Check className="w-4 h-4" /> حفظ</button>
            <button type="button" onClick={() => setForm(null)} className={btnGhost}><X className="w-4 h-4" /></button>
          </div>
        </form>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((g) => (
          <div key={g.id} data-testid={`gallery-row-${g.id}`} className="relative group rounded-xl overflow-hidden border border-[#28282D] aspect-[4/3]">
            <img src={g.image_url} alt={g.title} className={`w-full h-full object-cover ${g.visible ? "" : "opacity-40"}`} />
            <div className="absolute inset-x-0 bottom-0 bg-black/80 backdrop-blur-sm p-2.5 flex items-center justify-between gap-2">
              <div className="min-w-0">
                <div className="text-xs font-bold text-white truncate">{g.title}</div>
                <div className="text-[10px] text-zinc-500 truncate">{g.category}</div>
              </div>
              <div className="flex gap-1 shrink-0">
                <button data-testid={`gallery-toggle-${g.id}`} onClick={() => toggle(g)} className={`text-[10px] border rounded-full px-2 py-0.5 ${g.visible ? "text-green-400 border-green-400/40" : "text-zinc-500 border-zinc-600"}`}>
                  {g.visible ? "ظاهرة" : "مخفية"}
                </button>
                <button data-testid={`gallery-delete-${g.id}`} onClick={() => del(g.id)} className="text-zinc-400 hover:text-red-400"><Trash2 className="w-3.5 h-3.5" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
